import { supabase } from '../lib/supabase';

const SUPABASE_URL = import.meta.env?.VITE_SUPABASE_URL;

/**
 * Schedule 24h and 1h reminders for an appointment.
 * Calls the send-appointment-reminders edge function with action=schedule.
 */
export const scheduleAppointmentReminders = async ({
  appointment_id,
  client_name,
  client_email,
  client_phone,
  appointment_type,
  scheduled_date,
  scheduled_time,
  notary_name,
  consultant_name,
  location,
}) => {
  try {
    const { data, error } = await supabase?.functions?.invoke('send-appointment-reminders', {
      body: {
        action: 'schedule',
        appointment_id,
        client_name,
        client_email,
        client_phone,
        appointment_type,
        scheduled_date,
        scheduled_time,
        notary_name,
        consultant_name,
        location,
      },
    });

    if (error) {
      console.warn('[Reminders] Schedule failed:', error?.message);
      return { success: false, error: error?.message };
    }

    return { success: true, data };
  } catch (err) {
    console.warn('[Reminders] Schedule error:', err?.message);
    return { success: false, error: err?.message };
  }
};

/**
 * Validate a reschedule token and return appointment info.
 */
export const validateRescheduleToken = async (token) => {
  try {
    const { data, error } = await supabase?.functions?.invoke('handle-reschedule', {
      method: 'GET',
      headers: { 'x-token': token },
      body: { token },
    });

    if (error) return { valid: false, error: error?.message };
    return data;
  } catch (err) {
    return { valid: false, error: err?.message };
  }
};

/**
 * Confirm a reschedule via token.
 */
export const confirmReschedule = async ({ token, new_date, new_time }) => {
  try {
    const { data, error } = await supabase?.functions?.invoke('handle-reschedule', {
      body: { token, new_date, new_time },
    });

    if (error) return { success: false, error: error?.message };
    return { success: true, data };
  } catch (err) {
    return { success: false, error: err?.message };
  }
};

export default {
  scheduleAppointmentReminders,
  validateRescheduleToken,
  confirmReschedule,
};
